import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { instrumentRoutePerformance } from '@sentry/ember';

class ResourcesPeopleRoute extends Route {
  @service store;

  beforeModel() {
    return this.store.findAll('role');
  }
}

export default instrumentRoutePerformance(ResourcesPeopleRoute);
